module.exports = __webpack_public_path__ + "static/img/baLogo.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/baLogo.png
// module id = yHxE
// module chunks = 0